module.exports = __webpack_public_path__ + "static/media/cookedfishmorsel.c2677cae.webp";